"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _footer_styles = _interopRequireDefault(require("./footer_styles"));

var _footer_definition = _interopRequireDefault(require("./footer_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : FOOTER ~~~~~~~~~~ ========== */


var Footer = (0, _reactJss.default)(_footer_styles.default)(function (props) {
  return _react.default.createElement("footer", {
    id: "footer",
    className: "structure ".concat(props.classes.footer, " ").concat(props.klass ? props.klass : '')
  }, _react.default.createElement(_index.Group, {
    name: "info"
  }, _react.default.createElement(_index.Link, {
    type: "external",
    action: "".concat(_index2.url.company)
  }, _react.default.createElement(_index.Logo, {
    name: "insticator",
    text: "Insticator"
  })), _react.default.createElement("p", null, "Copyrights 2021\xA9")), _react.default.createElement(_index.Group, {
    name: "links",
    type: "nav"
  }, _react.default.createElement(_index.Link, {
    type: "external",
    text: "Terms and Conditions",
    action: "".concat(_index2.url.company, "/terms-of-service")
  })));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Footer, _footer_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Footer;
exports.default = _default;